/**
 * Created by PJPERF on 05.04.2017.
 */
import React from 'react'
import Cleave from 'cleave.js/react';
import Field from './field_class';

class InputField extends Field{
    showInput() {
        let value = (this.props.value) ? this.props.value : '';
        let autofocus = (this.props.autofocus) ? true : '';
        let maxlength = (this.props.maxlength) ? this.props.maxlength : 1000;
        if (this.props.input_control) {
            return (
                <Cleave id={this.getNamePostfix()} name={this.getNamePostfix()} type={this.props.type} data-tip={this.props.tip} value={value} autoComplete="off"
                        placeholder={this.props.placeholder}
                        options={this.props.input_control}
                        maxLength={maxlength}
                        autoCorrect="off" 
                        autoCapitalize="none" 
                        onChange={this.onChange.bind(this)}
                        disabled={this.isDisabled()}/>
            )
        } else {
            return (
                <input autoFocus={autofocus} id={this.getNamePostfix()} name={this.getNamePostfix()} data-tip={this.props.tip}
                        placeholder={this.props.placeholder}
                        autoCorrect="off" 
                        autoCapitalize="none" 
                        autoComplete="off"
                        type={this.props.type}
                        onChange={this.onChange.bind(this)}
                        maxLength={maxlength}
                        value={value}
                        disabled={this.isDisabled()}/>
            )
        }
    }
}

export default InputField;